/* The Spices Cuisine — Theme JavaScript */

document.addEventListener('DOMContentLoaded', function () {

  /* ---- Mobile Menu Toggle ---- */
  const menuToggle = document.querySelector('.menu-toggle');
  const mobileNav = document.querySelector('.mobile-nav');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', function () {
      mobileNav.classList.toggle('open');
      const spans = menuToggle.querySelectorAll('span');
      if (mobileNav.classList.contains('open')) {
        spans[0].style.transform = 'rotate(45deg) translate(5px, 5px)';
        spans[1].style.opacity = '0';
        spans[2].style.transform = 'rotate(-45deg) translate(5px, -5px)';
      } else {
        spans[0].style.transform = '';
        spans[1].style.opacity = '';
        spans[2].style.transform = '';
      }
    });
  }

  /* ---- Product Image Thumbnails ---- */
  const thumbnails = document.querySelectorAll('.product-thumbnails img');
  const mainImage = document.querySelector('.main-image img');
  if (thumbnails.length && mainImage) {
    thumbnails.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        mainImage.src = this.src;
        thumbnails.forEach(function (t) { t.classList.remove('active'); });
        this.classList.add('active');
      });
    });
  }

  /* ---- Quantity Selector ---- */
  const qtyBtns = document.querySelectorAll('.quantity-selector button');
  qtyBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      const input = this.parentElement.querySelector('input');
      let val = parseInt(input.value) || 1;
      if (this.dataset.action === 'decrease') {
        val = Math.max(1, val - 1);
      } else {
        val = val + 1;
      }
      input.value = val;
    });
  });

  /* ---- Sticky Header Shadow ---- */
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 10) {
        header.style.boxShadow = '0 4px 16px rgba(92,46,10,0.15)';
      } else {
        header.style.boxShadow = '0 2px 8px rgba(92,46,10,0.08)';
      }
    });
  }

  /* ---- Announcement Bar Close ---- */
  const annClose = document.querySelector('.announcement-close');
  const annBar = document.querySelector('.announcement-bar');
  if (annClose && annBar) {
    annClose.addEventListener('click', function () {
      annBar.style.display = 'none';
    });
  }

  /* ---- Add to Cart Feedback ---- */
  const addToCartForms = document.querySelectorAll('form[action="/cart/add"]');
  addToCartForms.forEach(function (form) {
    form.addEventListener('submit', function (e) {
      const btn = form.querySelector('.add-to-cart-btn');
      if (btn) {
        const original = btn.textContent;
        btn.textContent = 'Toegevoegd!';
        btn.style.background = '#5C2E0A';
        setTimeout(function () {
          btn.textContent = original;
          btn.style.background = '';
        }, 2000);
      }
    });
  });

  /* ---- Smooth scroll for anchor links ---- */
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* ---- Newsletter form ---- */
  const newsletterForm = document.querySelector('.newsletter-form');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const input = this.querySelector('input[type="email"]');
      const btn = this.querySelector('button');
      if (input && input.value) {
        btn.textContent = 'Aangemeld!';
        input.value = '';
        setTimeout(function () { btn.textContent = 'Aanmelden'; }, 3000);
      }
    });
  }

});
